<div class="docs-view">
  @if (isLoading()) {
    <app-spinner [message]="loadingMessage()" />
  } @else {
    <div class="docs-header">
      <div class="title-section">
        <h1>Documenti</h1>
        <p>{{ subtitle() }}</p>
      </div>
      <div class="header-actions">
       @if (showIngestButton() && !hasError() && documents().length > 0) {
          <span style="display: inline-block;" 
                [title]="isProcessing() ? 'Attendi il completamento del task in corso' : (!ingestEnabled() ? 'Seleziona almeno un file per abilitare l\'ingestione' : 'Avvia ingestion')">
            
            <button class="btn-primary main-shadow" 
                    (click)="ingestClicked.emit()" 
                    [disabled]="isLoading() || isProcessing() || !ingestEnabled()">
              <span class="material-symbols-outlined">
                {{ isProcessing() ? 'hourglass_top' : 'upload_file' }}
              </span>
              @if (isProcessing()) { Scan in corso... } @else { Ingestiona documenti }
            </button>
            
          </span>
        }
        <ng-content select="[table-actions]"></ng-content>
      </div>
    </div>

    <div class="table-card">
      <table class="modern-table">
        <thead>
          <tr>
            @if (isMultiSelectEnabled()) {
              <th class="checkbox-cell">
                <input type="checkbox" 
                       [checked]="isAllSelected()" 
                       [indeterminate]="isAllIndeterminate()"
                       (change)="toggleAll()">
              </th>
            }
            <th>Nome</th>
            <th>Tipologia</th>
            <th>Data di creazione</th>
            @if (showInfoAction()) {
              <th class="text-center">Azioni</th>
            }
          </tr>
        </thead>
        <tbody>
          @if (hasError()) {
            <tr>
              <td [colSpan]="(isMultiSelectEnabled() ? 1 : 0) + (showInfoAction() ? 4 : 3)" class="state-cell error-state">
                <div class="state-content">
                  <span class="material-symbols-outlined icon">error</span>
                  <p>Si è verificato un errore durante il recupero dei documenti.</p>
                </div>
              </td>
            </tr>
          } @else if (documents().length === 0) {
            <tr>
              <td [colSpan]="(isMultiSelectEnabled() ? 1 : 0) + (showInfoAction() ? 4 : 3)" class="state-cell empty-state">
                <div class="state-content">
                  <span class="material-symbols-outlined icon">folder_off</span>
                  <p>Non ci sono documenti da visualizzare.</p>
                </div>
              </td>
            </tr>
          } @else {
            
            @if (currentPath() !== basePath()) {
              <tr class="nav-up-row">
                <td [colSpan]="(isMultiSelectEnabled() ? 1 : 0) + (showInfoAction() ? 4 : 3)" class="p-0">
                  <div class="d-flex align-items-center justify-content-between w-100" style="padding: 10px 20px;">
                    
                    <button class="nav-content clickable-back font-bold border-0 bg-transparent" (click)="goBack()">
                      <span class="material-symbols-outlined">subdirectory_arrow_left</span>
                      Torna al livello superiore
                    </button>

                    <div class="breadcrumb-trail d-flex align-items-center gap-2 text-muted fw-normal">
                    <button class="crumb-link d-flex align-items-center border-0 bg-transparent p-0" 
                            (click)="goToFolder(basePath())" 
                            title="Torna alla radice">
                      <span class="material-symbols-outlined" style="font-size: 1.2rem;">home</span>
                    </button>
                    
                    @for (crumb of breadcrumb(); track crumb.fullPath; let isLast = $last) {
                      <span class="crumb-separator">/</span>
                      <button class="crumb-link border-0 bg-transparent p-0" 
                          [class.crumb-active]="isLast" 
                          [disabled]="isLast"
                          (click)="!isLast && goToFolder(crumb.fullPath)">
                        {{ crumb.name }}
                      </button>
                    }
                  </div>
                  </div>
                </td>
              </tr>
            }

            @for (item of visibleItems(); track item.fullPath) {
              <tr [class.selected-row]="isItemChecked(item) || isItemIndeterminate(item)">
                
                @if (isMultiSelectEnabled()) {
                  <td class="checkbox-cell">
                    <input type="checkbox" 
                           [checked]="isItemChecked(item)" 
                           [indeterminate]="isItemIndeterminate(item)"
                           (change)="toggleItem(item)">
                  </td>
                }

                @if (item.isFolder) {
                  <td class="font-bold clickable-cell p-0">
                    <button class="border-0 bg-transparent w-100 text-start d-flex align-items-center p-3" (click)="goToFolder(item.fullPath)">
                      <div class="file-name">
                        <span class="material-symbols-outlined folder-icon" [class.index-icon]="item.isIndexFolder">
                          {{ item.isIndexFolder ? 'database' : 'folder' }}
                        </span>
                        {{ item.name }}
                      </div>
                    </button>
                  </td>
                  <td>
                    <span class="type-tag folder-tag" [class.index-tag]="item.isIndexFolder">
                      {{ item.isIndexFolder ? 'Indice' : 'Cartella' }}
                    </span>
                  </td>
                  <td class="text-muted">-</td>
                  @if (showInfoAction()) { <td></td> }
                } @else {
                  <td class="font-bold">
                    <div class="file-name">
                      <span class="material-symbols-outlined file-icon">description</span>
                      {{ item.name }}
                    </div>
                  </td>
                  <td>
                    <span class="type-tag">{{ item.document?.tipologia }}</span>
                  </td>
                  <td class="text-muted">{{ item.document?.data | date:'dd/MM/yyyy - HH:mm' }}</td>
                  
                  @if (showInfoAction()) {
                    <td class="text-center">
                      <button class="action-btn" (click)="infoActionClicked.emit(item.document!)" title="Vedi dettaglio errore">
                        <span class="material-symbols-outlined">info</span>
                      </button>
                    </td>
                  }
                }
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  }
</div>